/**
 * GitHub Dark / GitHub Light, ported to Monaco.
 *
 * GENERATED FILE — do not hand-edit.
 * Source: `github-vscode-theme@6.3.5` ("GitHub Dark" / "GitHub Light").
 * Regenerate with `npm run build:monaco-theme`.
 *
 * VS Code themes key off TextMate scopes, which Monaco's Monarch tokenizers do
 * not emit; `scripts/generate-github-monaco-theme.ts` maps between the two and
 * explains why the upstream package cannot be a runtime dependency.
 */
import type * as Monaco from 'monaco-editor/editor/editor.api';

export type MonacoThemeMode = 'dark' | 'light';

const THEME_DATA: Record<MonacoThemeMode, Monaco.editor.IStandaloneThemeData> = {
  "dark": {
    "base": "vs-dark",
    "inherit": false,
    "rules": [
      {
        "token": "comment",
        "foreground": "6a737d"
      },
      {
        "token": "keyword",
        "foreground": "f97583"
      },
      {
        "token": "operator",
        "foreground": "f97583"
      },
      {
        "token": "string",
        "foreground": "9ecbff"
      },
      {
        "token": "number",
        "foreground": "79b8ff"
      },
      {
        "token": "constant",
        "foreground": "79b8ff"
      },
      {
        "token": "regexp",
        "foreground": "dbedff"
      },
      {
        "token": "type",
        "foreground": "b392f0"
      },
      {
        "token": "function",
        "foreground": "b392f0"
      },
      {
        "token": "namespace",
        "foreground": "b392f0"
      },
      {
        "token": "predefined",
        "foreground": "79b8ff"
      },
      {
        "token": "identifier",
        "foreground": "e1e4e8"
      },
      {
        "token": "variable",
        "foreground": "e1e4e8"
      },
      {
        "token": "delimiter",
        "foreground": "e1e4e8"
      },
      {
        "token": "tag",
        "foreground": "85e89d"
      },
      {
        "token": "metatag",
        "foreground": "85e89d"
      },
      {
        "token": "attribute.name",
        "foreground": "79b8ff"
      },
      {
        "token": "key",
        "foreground": "79b8ff"
      },
      {
        "token": "attribute.value",
        "foreground": "9ecbff"
      },
      {
        "token": "invalid",
        "foreground": "fdaeb7",
        "fontStyle": "italic"
      },
      {
        "token": "annotation",
        "foreground": "79b8ff"
      }
    ],
    "colors": {
      "editor.background": "#24292e",
      "editor.foreground": "#e1e4e8",
      "editorLineNumber.foreground": "#444d56",
      "editorLineNumber.activeForeground": "#e1e4e8",
      "editorCursor.foreground": "#c8e1ff",
      "editor.selectionBackground": "#3392ff44",
      "editor.inactiveSelectionBackground": "#3392ff22",
      "editor.lineHighlightBackground": "#2b3036",
      "editorWidget.background": "#1f2428",
      "editorIndentGuide.background": "#2f363d",
      "editorBracketMatch.background": "#17e5e650",
      "editorBracketMatch.border": "#17e5e600",
      "scrollbarSlider.background": "#6a737d33",
      "scrollbarSlider.hoverBackground": "#6a737d44"
    }
  },
  "light": {
    "base": "vs",
    "inherit": false,
    "rules": [
      {
        "token": "comment",
        "foreground": "6a737d"
      },
      {
        "token": "keyword",
        "foreground": "d73a49"
      },
      {
        "token": "operator",
        "foreground": "d73a49"
      },
      {
        "token": "string",
        "foreground": "032f62"
      },
      {
        "token": "number",
        "foreground": "005cc5"
      },
      {
        "token": "constant",
        "foreground": "005cc5"
      },
      {
        "token": "regexp",
        "foreground": "032f62"
      },
      {
        "token": "type",
        "foreground": "6f42c1"
      },
      {
        "token": "function",
        "foreground": "6f42c1"
      },
      {
        "token": "namespace",
        "foreground": "6f42c1"
      },
      {
        "token": "predefined",
        "foreground": "005cc5"
      },
      {
        "token": "identifier",
        "foreground": "24292e"
      },
      {
        "token": "variable",
        "foreground": "24292e"
      },
      {
        "token": "delimiter",
        "foreground": "24292e"
      },
      {
        "token": "tag",
        "foreground": "22863a"
      },
      {
        "token": "metatag",
        "foreground": "22863a"
      },
      {
        "token": "attribute.name",
        "foreground": "005cc5"
      },
      {
        "token": "key",
        "foreground": "005cc5"
      },
      {
        "token": "attribute.value",
        "foreground": "032f62"
      },
      {
        "token": "invalid",
        "foreground": "b31d28",
        "fontStyle": "italic"
      },
      {
        "token": "annotation",
        "foreground": "005cc5"
      }
    ],
    "colors": {
      "editor.background": "#ffffff",
      "editor.foreground": "#24292e",
      "editorLineNumber.foreground": "#1b1f234d",
      "editorLineNumber.activeForeground": "#24292e",
      "editorCursor.foreground": "#044289",
      "editor.selectionBackground": "#0366d625",
      "editor.inactiveSelectionBackground": "#0366d611",
      "editor.lineHighlightBackground": "#f6f8fa",
      "editorWidget.background": "#f6f8fa",
      "editorIndentGuide.background": "#eff2f6",
      "editorBracketMatch.background": "#34d05840",
      "editorBracketMatch.border": "#34d05800",
      "scrollbarSlider.background": "#959da533",
      "scrollbarSlider.hoverBackground": "#959da544"
    }
  }
};

/** The Monaco theme data for a mode. Registered by `loader.ts` via `defineTheme`. */
export function githubMonacoTheme(mode: MonacoThemeMode): Monaco.editor.IStandaloneThemeData {
  return THEME_DATA[mode];
}
